import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-row" }
const _hoisted_2 = { class: "form-buttons" }

import { ref, reactive } from 'vue';
import type { FormInstance, FormRules } from 'element-plus';
import type { Position } from '@/types/position';
import { 
  APPLICATION_STATUS_MAP, 
  WORK_TYPE_OPTIONS, 
  PRIORITY_OPTIONS,
  CURRENCY_OPTIONS
} from '@/types/position';
import { Link } from '@element-plus/icons-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PositionForm',
  props: {
    position: {},
    loading: { type: Boolean }
  },
  emits: ["submit", "cancel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const formRef = ref<FormInstance>();
const formData = reactive({
  id: props.position?.id,
  companyId: props.position?.companyId,
  title: props.position?.title || '',
  jobUrl: props.position?.jobUrl || '',
  description: props.position?.description || '',
  requirements: props.position?.requirements || '',
  minSalary: props.position?.minSalary || undefined,
  maxSalary: props.position?.maxSalary || undefined,
  salaryCurrency: props.position?.salaryCurrency || 'CNY',
  workType: props.position?.workType || '',
  applicationStatus: props.position?.applicationStatus || 'not_started',
  deadline: props.position?.deadline || '',
  priority: props.position?.priority || 2,
});

const rules: FormRules = {
  title: [
    { required: true, message: '职位名称不能为空', trigger: 'blur' },
    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
  ],
  jobUrl: [
    { required: true, message: '职位招聘链接不能为空', trigger: 'blur' },
    { 
      pattern: /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/, 
      message: '请输入有效的URL', 
      trigger: 'blur' 
    }
  ],
  applicationStatus: [
    { required: true, message: '请选择投递状态', trigger: 'change' }
  ]
};

// 打开URL链接
const openUrl = (url: string) => {
  let finalUrl = url;
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    finalUrl = 'https://' + url;
  }
  window.open(finalUrl, '_blank');
};

// 提交表单
const submitForm = async () => {
  if (!formRef.value) return;
  
  await formRef.value.validate((valid, fields) => {
    if (valid) {
      emit('submit', {
        ...formData,
        jobUrl: formData.jobUrl ? 
          (formData.jobUrl.startsWith('http') ? formData.jobUrl : `https://${formData.jobUrl}`)
          : '',
      });
    }
  });
};

// 取消表单
const cancelForm = () => {
  emit('cancel');
};

// 暴露方法给父组件
__expose({
  submitForm
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    ref_key: "formRef",
    ref: formRef,
    model: formData,
    rules: rules,
    "label-width": "100px",
    class: "position-form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: "职位名称",
        prop: "title"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.title,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.title) = $event)),
            placeholder: "请输入职位名称",
            clearable: ""
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "职位链接",
        prop: "jobUrl"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.jobUrl,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.jobUrl) = $event)),
            placeholder: "请输入职位招聘链接",
            clearable: ""
          }, {
            append: _withCtx(() => [
              (formData.jobUrl)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (openUrl(formData.jobUrl)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Link))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "工作类型",
        prop: "workType"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formData.workType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.workType) = $event)),
            placeholder: "请选择工作类型",
            class: "full-width",
            clearable: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WORK_TYPE_OPTIONS), (option) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: option.value,
                  label: option.label,
                  value: option.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "职位描述" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.description,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.description) = $event)),
            type: "textarea",
            rows: 3,
            placeholder: "请输入职位描述"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "职位要求" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: formData.requirements,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.requirements) = $event)),
            type: "textarea",
            rows: 3,
            placeholder: "请输入职位要求"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_divider, null, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [
          _createTextVNode("薪资信息")
        ])),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form_item, {
          label: "最低薪资",
          class: "form-col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: formData.minSalary,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.minSalary) = $event)),
              precision: 2,
              step: 1000,
              min: 0,
              "controls-position": "right",
              class: "full-width"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "最高薪资",
          class: "form-col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input_number, {
              modelValue: formData.maxSalary,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.maxSalary) = $event)),
              precision: 2,
              step: 1000,
              min: formData.minSalary || 0,
              "controls-position": "right",
              class: "full-width"
            }, null, 8, ["modelValue", "min"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "币种",
          class: "form-col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formData.salaryCurrency,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.salaryCurrency) = $event)),
              placeholder: "请选择币种",
              class: "full-width"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(CURRENCY_OPTIONS), (option) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: option.value,
                    label: option.label,
                    value: option.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_divider, null, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [
          _createTextVNode("投递信息")
        ])),
        _: 1
      }),
      _createVNode(_component_el_form_item, {
        label: "投递状态",
        prop: "applicationStatus"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formData.applicationStatus,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.applicationStatus) = $event)),
            placeholder: "请选择投递状态",
            class: "full-width"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(APPLICATION_STATUS_MAP), (label, value) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: value,
                  label: label,
                  value: value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "截止日期" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_date_picker, {
            modelValue: formData.deadline,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.deadline) = $event)),
            type: "date",
            placeholder: "请选择截止日期",
            format: "YYYY-MM-DD",
            "value-format": "YYYY-MM-DD",
            class: "full-width"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, { label: "优先级" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_select, {
            modelValue: formData.priority,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.priority) = $event)),
            placeholder: "请选择优先级",
            class: "full-width"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PRIORITY_OPTIONS), (option) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: option.value,
                  label: option.label,
                  value: option.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_el_button, { onClick: cancelForm }, {
              default: _withCtx(() => _cache[14] || (_cache[14] = [
                _createTextVNode("取消")
              ])),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submitForm,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("提交")
              ])),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model"]))
}
}

})